import Swiper from 'swiper';
import { refs, domReady, debounce } from '../modules/utils.js';
import { test as testMedia } from '../modules/match-media.js';

class LstyleSlider extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
    this.#slider();
  }

  disconnectedCallback() {
    // Remove debounced resize listener if present
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
    }
  }

  #listeners() {
    this.refs.prev?.addEventListener('click', () => {
      if (this.slider) {
        this.slider.slidePrev();
      }
    });

    this.refs.next?.addEventListener('click', () => {
      if (this.slider) {
        this.slider.slideNext();
      }
    });

    // Debounced window resize -> reset slider
    this._onResize = debounce(() => {
      this.#resetSlider();
    }, 200);
    window.addEventListener('resize', this._onResize);
  }

  #resetSlider() {
    if (this.slider?.destroy) {
      this.slider.destroy(true, true);
      this.slider = null;
    }
    this.#slider();
  }

  #slider() {
    if (!this.refs.slider) return;
    const slidesCount = this.refs.slides?.length ?? 0;
    const isMobile = testMedia('small');
    if (slidesCount < 1) return;

    // Ensure nav visibility recalculates on resize
    if (this.refs.nav) {
      this.refs.nav.style.display = (!isMobile && this.refs.slides.length < 3) ? 'none' : '';
    }

    let slidesPerView = 3;
    if (this.dataset.cards) {
      slidesPerView = parseInt(this.dataset.cards);
    }
    if (isMobile) {
      slidesPerView = 1;
    }

    this.slider = new Swiper(
      this.refs.slider,
      {
        slidesPerView,
        spaceBetween: 26,
        loop: false,
        loopAdditionalSlides: 1
      }
    );

    // this.slider.on('slideChange', () => {
    //   this.dataset.index = this.slider.realIndex;
    // });
  }
}

customElements.define('lstyle-slider', LstyleSlider);
